// extracted by mini-css-extract-plugin
export default {"container":"index-module__g5WiK"};